import { Injectable } from '@angular/core';
import { Component, OnInit, Inject, ViewChild, ElementRef, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { Location } from '../../location/location';
import { Plan } from '../../plans/plan';
import { Customer } from '../../customers/customers';
import { Observable, empty, forkJoin } from 'rxjs';
import { map, debounceTime, finalize, switchMap, tap, startWith, filter, mergeMap } from 'rxjs/operators';
import { API, APIDefinition, Columns, Config, DefaultConfig } from 'ngx-easy-table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Contact } from '../../contacts/contact';
import { Subdivision } from '../../subdivisions/subdivision';
import { MatRipple } from '@angular/material/core';
import { MessagerComponent } from '../../messager/messager/messager.component';

import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { AuthService } from '../../auth.service';
import { LoggingService } from '../../utils/logging.service';
import { ScheduleService } from '../../schedule/schedule.service';
import { io } from 'socket.io-client';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';


//Font Awesome Icons
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { faFileImport } from '@fortawesome/free-solid-svg-icons';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { faCamera } from '@fortawesome/free-solid-svg-icons';
import { faHardHat } from '@fortawesome/free-solid-svg-icons';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faClipboard } from '@fortawesome/free-solid-svg-icons';
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { faLeaf } from '@fortawesome/free-solid-svg-icons';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { GridDeleteComponent } from '../../utils/grid-delete-component';
import { ContactsService } from '../../contacts/contacts.service';
import { GlobalEmailService } from '../../utils/globalemail.service';
import { HvacSubmissionService } from './hvacsubmission.service';


@Component({
  selector: 'app-hvac-review',
  templateUrl: './hvacsubmission.component.html',
  styleUrls: ['./hvacsubmisison.component.css']
})
export class HvacsubmissionComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<HvacsubmissionComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private fb:FormBuilder, public service: HvacSubmissionService, private messager: MessagerComponent, public contactService: ContactsService) {}


  currSystem;
  cooling;
  coolpct;
  difference;
  condenser;
  evaporator;
  furnace;
  name;
  raterwa;
  ratercfa;
  raternooc;
  ratershgc;
  ratergshgc
  ratervent;
  higher;

  dessheatgaine;
  dessheatgainn;
  dessheatgainne;
  dessheatgainnw;
  dessheatgains;
  dessheatgainse;
  dessheatgainsw;
  dessheatgainw;

  destotlheatgaine;
  destotlheatgainn;
  destotlheatgainne;
  destotlheatgainnw;
  destotlheatgains;
  destotlheatgainse;
  destotlheatgainsw;
  destotlheatgainw;

  deslheatgain;
  totaldescap;
  maxtotal;


  designeremail;

  form = new FormGroup({
    wa : new FormControl(this.data.submittedData[0].wa || 0),
    cfa : new FormControl(this.data.submittedData[0].cfa || 0),
    shgc : new FormControl(this.data.submittedData[0].shgc || 0),
    noocupants : new FormControl(this.data.submittedData[0].noocupants || 0),
    outdoortemplocation : new FormControl(this.data.submittedData[0].outdoortemplocation.trim() || ''),
    mechanicalvent : new FormControl(this.data.submittedData[0].mechanicalvent || 0),

  });


  ngOnInit(){

    //load RH plan data
    console.log(this.data);


    this.currSystem = 0;


    this.designeremail = this.data.submittedData[0].designeremail;
    //preload first system
    this.cooling = this.data.submittedData[this.currSystem].coolingsizinglimit;
    this.coolpct = this.data.submittedData[0].coolsizingpct;
    this.difference = this.data.submittedData[0].difference;
    this.name = this.data.submittedData[0].name;

    this.dessheatgaine = this.data.submittedData[0].dessheatgaine;
    this.dessheatgainn = this.data.submittedData[0].dessheatgainn;
    this.dessheatgainne = this.data.submittedData[0].dessheatgainne;
    this.dessheatgainnw = this.data.submittedData[0].dessheatgainnw;
    this.dessheatgains = this.data.submittedData[0].dessheatgains;
    this.dessheatgainse = this.data.submittedData[0].dessheatgainse;
    this.dessheatgainsw = this.data.submittedData[0].dessheatgainsw;
    this.dessheatgainw = this.data.submittedData[0].dessheatgainw;

    this.destotlheatgaine = this.data.submittedData[0].destotlheatgaine;
    this.destotlheatgainn = this.data.submittedData[0].destotlheatgainn;
    this.destotlheatgainne = this.data.submittedData[0].destotlheatgainne;
    this.destotlheatgainnw = this.data.submittedData[0].destotlheatgainnw;
    this.destotlheatgains = this.data.submittedData[0].destotlheatgains;
    this.destotlheatgainse = this.data.submittedData[0].destotlheatgainse;
    this.destotlheatgainsw = this.data.submittedData[0].destotlheatgainsw;
    this.destotlheatgainw = this.data.submittedData[0].destotlheatgainw;

    this.deslheatgain = this.data.submittedData[0].deslheatgain;
    this.totaldescap = this.data.submittedData[0].totaldescap;

    this.maxtotal = this.calculateMax();

    this.service.getHVACequipValues(this.data.submittedData[0].sbmt_eq_id).subscribe(
      (res)=> {
        console.log(res);
        this.condenser = res.Equipment.condensermn;
        this.evaporator = res.Equipment.evapmn;
        this.furnace = res.Equipment.furnacemn || '(Not Listed)';
      },err => {
        this.messager.openSnackBar('Could not load equipment', '','errorAlert');
      }
    )


    //laod rater plan data
    this.service.getRaterHvacReview(this.data.submittedData.plan_id).subscribe(
      (res) => {
        this.raterwa = res.Plan.windowarea;
        this.ratercfa = res.Plan.cfa;
        this.raternooc = parseInt(res.Plan.bedrooms) + 1;
        console.log(res);
      },err => {
        console.log(err);
      }
    )

    this.service.getLastRaterform(this.data.submittedData[0].location_id).subscribe(
      (res) => {
        console.log(res);
        this.ratergshgc = res.FormData.glass_door_shgc || 0;
        this.ratershgc = res.FormData.window_shgc || 0;
        this.ratervent = res.FormData.vent_rate_total;
        this.higher = Math.max(this.ratergshgc, this.ratershgc);

      },err=> {
        console.log(err);
      }
    )


    //set first system tab active
    //document.getElementById('system_1').className='tooltip tab-link active';

  }


/*
  completeReview(complete: boolean): void {


          var dated = new Date(Date.now());
							var dd = dated.getDate().toFixed(0);
							var mm = (dated.getMonth()+1).toFixed(0);

							var yyyy = dated.getFullYear();
							if(parseInt(dd)<10){
							    dd='0';
							}
							if(parseInt(mm)<10){
							    mm='0'+mm;
							}

							var today = mm+'-'+dd+'-'+yyyy;




					var newSubmit =
					{
						hvac_dsn_descrpt : this.data.submittedData[0].hvac_dsn_descrpt,
						hvaccfa : (document.getElementById("cfaInput") as HTMLInputElement).value,
						hvacwa	: (document.getElementById("waInput") as HTMLInputElement).value,
						hvacshgc : (document.getElementById("shgcInput") as HTMLInputElement).value,
						hvactemploc : (document.getElementById("outdoorInput") as HTMLInputElement).value,
						hvacnooc : (document.getElementById("noocInput") as HTMLInputElement).value,
						reviewcomplete : (document.getElementById('completeCheck') as HTMLInputElement).checked,
						hvac_design_id : this.data.submittedData[0].hvac_design_id,
						date : today,
						location_id : this.data.submittedData[0].location_id,
						sbmt_dsn_id : this.data.submittedData[0].sbmt_dsn_id
					};


					if(this.data.submittedData[0].sbmt_dsn_id > 0){
						//alertify.success('called.');
						this.service.updateHVACBasics(this.data.submittedData[0].sbmt_dsn_id, newSubmit)
						.subscribe(
              (response) => {
							console.log(response);
							this.messager.openSnackBar('Updated on HVAC end.', '', 'successAlert');
						},err=>{
							this.messager.openSnackBar('Error, updating the basics.', '', 'successAlert');
            });
					} else {
              this.messager.openSnackBar('Updated on HVAC end.', '', 'errorAlert');
					}

          let newNotes = {
            hvacerrors 	: (document.getElementById('errorCheck') as HTMLInputElement).checked,
            hvacnotes 	: (document.getElementById("emailnotes") as HTMLInputElement).value,
            reviewcomplete : (document.getElementById('completeCheck') as HTMLInputElement).checked
          }


					this.service.hvacNotes(this.data.submittedData[0].location_id, newNotes)
					.subscribe((response)=>{
						console.log(response);
						this.service.designReview(newSubmit)
						.subscribe((response) =>{
							console.log(response);
							if(!response.data.Error)
							{
								if((document.getElementById('errorCheck') as HTMLInputElement).checked)
								{
									this.service.resetDesign(this.data.submittedData[0].location_id)
									.subscribe((response) =>
									{
										console.log(response);
										this.messager.openSnackBar('This will be returned to the contractor', '', 'successAlert');
									},err => {
										this.messager.openSnackBar('Error: resetting the design.', '', 'errorAlert');
                  });
								}
								this.messager.openSnackBar('Your reviews saved!', '', 'successAlert');
							}
							else{
								this.messager.openSnackBar(response.data.Message, '', 'errorAlert');
							}
						}, err => {

            });

					},err => {
								this.messager.openSnackBar('Error: submitting notes.', '', 'errorAlert');
          });


  }
*/

  calcDiff(val1, val2): number {
    return Math.abs(val1 - val2);
  }

  changeSystem(evt, num): void {
    this.currSystem = num;
    this.cooling = this.data.submittedData[num].coolingsizinglimit;
    this.coolpct = this.data.submittedData[num].coolsizingpct;
    this.difference = this.data.submittedData[num].difference;
    this.name = this.data.submittedData[num].name;

    this.dessheatgaine = this.data.submittedData[num].dessheatgaine;
    this.dessheatgainn = this.data.submittedData[num].dessheatgainn;
    this.dessheatgainne = this.data.submittedData[num].dessheatgainne;
    this.dessheatgainnw = this.data.submittedData[num].dessheatgainnw;
    this.dessheatgains = this.data.submittedData[num].dessheatgains;
    this.dessheatgainse = this.data.submittedData[num].dessheatgainse;
    this.dessheatgainsw = this.data.submittedData[num].dessheatgainsw;
    this.dessheatgainw = this.data.submittedData[num].dessheatgainw;

    this.destotlheatgaine = this.data.submittedData[num].destotlheatgaine;
    this.destotlheatgainn = this.data.submittedData[num].destotlheatgainn;
    this.destotlheatgainne = this.data.submittedData[num].destotlheatgainne;
    this.destotlheatgainnw = this.data.submittedData[num].destotlheatgainnw;
    this.destotlheatgains = this.data.submittedData[num].destotlheatgains;
    this.destotlheatgainse = this.data.submittedData[num].destotlheatgainse;
    this.destotlheatgainsw = this.data.submittedData[num].destotlheatgainsw;
    this.destotlheatgainw = this.data.submittedData[num].destotlheatgainw;

    this.deslheatgain = this.data.submittedData[num].deslheatgain;
    this.totaldescap = this.data.submittedData[num].totaldescap;


    //get Equipment using sbmt_dsn_id
    this.service.getHVACequipValues(this.data.submittedData[num].sbmt_eq_id).subscribe(
      (res)=> {
        this.condenser = res.Equipment.condensermn;
        this.evaporator = res.Equipment.evapmn;
        this.furnace = res.Equipment.furnacemn || '(Not Listed)';
      },err => {
        this.messager.openSnackBar('Could not load equipment', '','errorAlert');
      }
    )

    let tablink, i;
    tablink = document.getElementsByClassName("tab-link");
    for (i = 0; i < tablink.length; i++) {
      tablink[i].className = tablink[i].className.replace(" active", "");
    }

    //console.log(event);
    evt.currentTarget.className += " active";

  }

  updateDesHeatGain(): void {

    var desl = document.getElementById('desl') as HTMLInputElement;
    var ndsn = document.getElementById('ndsn') as HTMLInputElement;
    var edsn = document.getElementById('edsn') as HTMLInputElement;
    var sdsn = document.getElementById('sdsn') as HTMLInputElement;
    var wdsn = document.getElementById('wdsn') as HTMLInputElement;
    var nedsn = document.getElementById('nedsn') as HTMLInputElement;
    var sedsn = document.getElementById('sedsn') as HTMLInputElement;
    var swdsn = document.getElementById('swdsn') as HTMLInputElement;
    var nwdsn = document.getElementById('nwdsn') as HTMLInputElement;

    this.deslheatgain = parseInt(desl.value);

    //update totalheatgains
    //this.destotlheatgainn = ( parseInt(ndsn.value) +  parseInt(desl.value)).toFixed();
    console.log(desl, ndsn, this.destotlheatgainn);

    this.destotlheatgaine = ( parseInt(edsn.value) + parseInt(desl.value)).toFixed();
    this.destotlheatgainn = ( parseInt(ndsn.value) + parseInt(desl.value)).toFixed();
    this.destotlheatgainne = ( parseInt(nedsn.value) + parseInt(desl.value)).toFixed();
    this.destotlheatgainnw = ( parseInt(nwdsn.value) + parseInt(desl.value)).toFixed();
    this.destotlheatgains = ( parseInt(sdsn.value) + parseInt(desl.value)).toFixed();
    this.destotlheatgainse = ( parseInt(sedsn.value) + parseInt(desl.value)).toFixed();
    this.destotlheatgainsw = ( parseInt(swdsn.value) + parseInt(desl.value)).toFixed();
    this.destotlheatgainw = ( parseInt(wdsn.value) + parseInt(desl.value)).toFixed();
  }

  calculateMax(): number {
    let numArray = [];

    numArray.push(parseInt(this.destotlheatgaine));
    numArray.push(parseInt(this.destotlheatgainn));
    numArray.push(parseInt(this.destotlheatgainne));
    numArray.push(parseInt(this.destotlheatgainnw));
    numArray.push(parseInt(this.destotlheatgains));
    numArray.push(parseInt(this.destotlheatgainse));
    numArray.push(parseInt(this.destotlheatgainsw));
    numArray.push(parseInt(this.destotlheatgainw));

    let max = Math.max(...numArray);
    let min = Math.min(...numArray);

    this.difference = max - min;

    console.log(max, min, this.difference);

    return max;


  }

  updateDifference() : void {

    let numArray = [];

    numArray.push(parseInt(this.destotlheatgaine));
    numArray.push(parseInt(this.destotlheatgainn));
    numArray.push(parseInt(this.destotlheatgainne));
    numArray.push(parseInt(this.destotlheatgainnw));
    numArray.push(parseInt(this.destotlheatgains));
    numArray.push(parseInt(this.destotlheatgainse));
    numArray.push(parseInt(this.destotlheatgainsw));
    numArray.push(parseInt(this.destotlheatgainw));

    let max = Math.max(...numArray);
    let min = Math.min(...numArray);

    this.difference = max - min;

    console.log(max, min, this.difference);

    this.maxtotal = max;
    this.updateCooling(max);


  }

  updateCooling(maxtotal) : void {

    //$scope.data[index].coolsizingpct = Number($scope.data[index].totaldescap) / Number($scope.data[index].maxtotal) * 100;

    let tot = document.getElementById('totcap') as HTMLInputElement;
    this.totaldescap = parseInt(tot.value);

    this.coolpct = (parseInt(this.totaldescap) / parseInt(maxtotal) * 100).toFixed(1)
    //this.cooling = this.coolpct;


  }

  updateIndividualHeatGain(id:string, letters): void {

    let elem = document.getElementById(id) as HTMLInputElement;

    let direction = id.substring(0,letters);

    let property = 'destotlheatgain' + direction;
    this[property] = parseInt(elem.value) + parseInt(this.deslheatgain);

    console.log(direction,property,parseInt(elem.value) + this.deslheatgain);

    this.updateDifference();

  }

  equipText() : string {

      if (this.coolpct > 89 && this.coolpct < 131){
        return 'cfa-txt';
      }else {
        return 'cfa-txt-err';
      }
  }

  loadText() : string {

    if (this.difference < 7){
      return 'cfa-txt';
    }else {
      return 'cfa-txt-err';
    }
}


  getColor(icon): string {

    switch(icon){
      case 'cfa':
      if(this.form.get('cfa').value >= (this.ratercfa - 100) && this.form.get('cfa').value <= (parseInt(this.ratercfa) + 300) ){
        return 'fillGreen';
      }else{
        return 'fillRed';
      }
      case 'wa':
        if(this.raterwa < 500){
          if(this.form.get('wa').value >= (this.raterwa - 15) && this.form.get('wa').value <= (parseInt(this.raterwa) + 60) ){
            document.getElementById('waInput').style.color = "#44AC2A";
            return 'fillGreen';
          }else{
            document.getElementById('waInput').style.color = "red";
            return 'fillRed';
          }
        }else{
          if(this.form.get('wa').value >= (parseInt(this.raterwa) - (parseInt(this.raterwa) * 0.03)) && this.form.get('wa').value <= (parseInt(this.raterwa) + (parseInt(this.raterwa) * 0.12 ) ) ){
            document.getElementById('waInput').style.color = "#44AC2A";
            return 'fillGreen';
          }else{
            document.getElementById('waInput').style.color = "red";
            return 'fillRed';
          }
        }
      case 'noocupants':
        if(Math.abs(this.form.get('noocupants').value - this.raternooc) <= 2  ){
          document.getElementById('shgcInput').style.color = "#44AC2A";
          return 'fillGreen';
        }else{
          document.getElementById('shgcInput').style.color = "red";
          return 'fillRed';
        }
      case 'shgc':
        if(Math.abs(this.higher - this.form.get('shgc').value) < 0.1 ){
          document.getElementById('shgcInput').style.color = "#44AC2A";
          return 'fillGreen';
        }else{
          document.getElementById('shgcInput').style.color = "red";
          return 'fillRed';
        }
      default:
      return 'fillGreen';

    }

  }

  getColorText(icon): string {

    switch(icon){
      case 'cfa':
        if(this.form.get('cfa').value >= (this.ratercfa - 100) && this.form.get('cfa').value <= (parseInt(this.ratercfa) + 300) ){
          document.getElementById('cfaInput').style.color = "#44AC2A";
          return 'cfa-txt';
        }else{
          document.getElementById('cfaInput').style.color = "red";
          return 'cfa-txt-err';
        }
      case 'wa':
        if(this.raterwa < 500){
          if(this.form.get('wa').value >= (this.raterwa - 15) && this.form.get('wa').value <= (parseInt(this.raterwa) + 60) ){
            document.getElementById('waInput').style.color = "#44AC2A";
            return 'cfa-txt';
          }else{
            document.getElementById('waInput').style.color = "red";
            return 'cfa-txt-err';
          }
        }else{
          if(this.form.get('wa').value >= (parseInt(this.raterwa) - (parseInt(this.raterwa) * 0.03)) && this.form.get('wa').value <= (parseInt(this.raterwa) + (parseInt(this.raterwa) * 0.12 ) ) ){
            document.getElementById('waInput').style.color = "#44AC2A";
            return 'cfa-txt';
          }else{
            document.getElementById('waInput').style.color = "red";
            return 'cfa-txt-err';
          }
        }
      case 'shgc':
          if(Math.abs(this.higher - this.form.get('shgc').value) < 0.1 ){
            document.getElementById('shgcInput').style.color = "#44AC2A";
            return 'cfa-txt';
          }else{
            document.getElementById('shgcInput').style.color = "red";
            return 'cfa-txt-err';
          }
      case 'noocupants':
        if(Math.abs(this.form.get('noocupants').value - this.raternooc) <= 2  ){
          document.getElementById('shgcInput').style.color = "#44AC2A";
          return 'cfa-txt';
        }else{
          document.getElementById('shgcInput').style.color = "red";
          return 'cfa-txt-err';
        }
      default:
      return 'cfa-txt';

    }

  }


  navigateTo(page):void {

    var i, pages;

    //set all pages to display none
    pages = document.getElementsByClassName("page");
    for (i = 0; i < pages.length; i++) {
      pages[i].style.display = "none";
    }

    document.getElementById(page).style.display = "block";
    document.getElementById('system_1').className='tab-link active';

    //evt.currentTarget.className += " active";

  }



  saveDesign() : void {

    var newDes = {
      sbmt_dsn_id : this.data.submittedData[0].sbmt_dsn_id,
      outdoortemplocation : this.form.get('outdoortemplocation').value,
      noocupants : this.form.get('noocupants').value,
      cfa: this.form.get('cfa').value,
      wa : this.form.get('wa').value,
      shgc : this.form.get('shgc').value
    };

    this.service.updateDesignStamp(this.data.submittedData[0].sbmt_dsn_id,newDes).subscribe(
      (response) =>
      {
      console.log(response);
      if(response.Error)
      {
        this.messager.openSnackBar("Form did not save due to: [ " + response.Message + "] ", '', 'errorAlert');
      }
      else{
        this.messager.openSnackBar("Saved Successfully", '', 'successAlert');
      }
    });
  }


  saveSystemAndEquipment(index): void {

    var desl = document.getElementById('desl') as HTMLInputElement;
    var ndsn = document.getElementById('ndsn') as HTMLInputElement;
    var edsn = document.getElementById('edsn') as HTMLInputElement;
    var sdsn = document.getElementById('sdsn') as HTMLInputElement;
    var wdsn = document.getElementById('wdsn') as HTMLInputElement;
    var nedsn = document.getElementById('nedsn') as HTMLInputElement;
    var sedsn = document.getElementById('sedsn') as HTMLInputElement;
    var swdsn = document.getElementById('swdsn') as HTMLInputElement;
    var nwdsn = document.getElementById('nwdsn') as HTMLInputElement;

    this.deslheatgain = parseInt(desl.value);

    //update totalheatgains
    //this.destotlheatgainn = ( parseInt(ndsn.value) +  parseInt(desl.value)).toFixed();
    console.log(desl, ndsn, this.destotlheatgainn);

    this.destotlheatgaine = ( parseInt(edsn.value) + parseInt(desl.value)).toFixed();
    this.destotlheatgainn = ( parseInt(ndsn.value) + parseInt(desl.value)).toFixed();
    this.destotlheatgainne = ( parseInt(nedsn.value) + parseInt(desl.value)).toFixed();
    this.destotlheatgainnw = ( parseInt(nwdsn.value) + parseInt(desl.value)).toFixed();
    this.destotlheatgains = ( parseInt(sdsn.value) + parseInt(desl.value)).toFixed();
    this.destotlheatgainse = ( parseInt(sedsn.value) + parseInt(desl.value)).toFixed();
    this.destotlheatgainsw = ( parseInt(swdsn.value) + parseInt(desl.value)).toFixed();
    this.destotlheatgainw = ( parseInt(wdsn.value) + parseInt(desl.value)).toFixed();

  								var newSys =
  								{
  									    sbmt_sys_id: this.data.submittedData[index].sbmt_sys_id,
						            coolsizingpct : parseInt(this.coolpct),
                        dessheatgainn: parseInt(ndsn.value),
                        dessheatgainne: parseInt(nedsn.value),
                        dessheatgaine: parseInt(edsn.value),
                        dessheatgainse: parseInt(sedsn.value),
                        dessheatgains: parseInt(sdsn.value),
                        dessheatgainsw: parseInt(swdsn.value),
                        dessheatgainw: parseInt(wdsn.value),
                        dessheatgainnw: parseInt(nwdsn.value),
                        deslheatgain : parseInt(desl.value),
                        destotlheatgainn: ( parseInt(ndsn.value) + parseInt(desl.value)),
                        destotlheatgainne: ( parseInt(nedsn.value) + parseInt(desl.value)),
                        destotlheatgainnw: ( parseInt(wdsn.value) + parseInt(desl.value)),
                        destotlheatgains: ( parseInt(nwdsn.value) + parseInt(desl.value)),
                        destotlheatgainse: ( parseInt(sedsn.value) + parseInt(desl.value)),
                        destotlheatgainsw: ( parseInt(swdsn.value) + parseInt(desl.value)),
                        destotlheatgaine: ( parseInt(edsn.value) + parseInt(desl.value)),
                        destotlheatgainw: ( parseInt(nwdsn.value) + parseInt(desl.value)),
                        maxtotal: this.calculateMax(),
                        difference : parseInt(this.difference)
  								};


                  var lcondensermn = document.getElementById('condensermnInput') as HTMLInputElement;
                  var lfurnacemn = document.getElementById('furnaceInput') as HTMLInputElement;
                  var levapmn = document.getElementById('evaporatorInput') as HTMLInputElement;
                  var ltotaldescap = document.getElementById('totcap') as HTMLInputElement;


  								var newEq = {
													            sbmt_eq_id:  this.data.submittedData[index].sbmt_eq_id,
													            condensermn :  lcondensermn.value.trim(),
													            furnacemn : lfurnacemn.value.trim(),
													            evapmn : levapmn.value.trim(),
													            totaldescap: ltotaldescap.value
							  	};

                  console.log(newEq);


                  //update system
  								this.service.updateSystemStamp(this.data.submittedData[index].sbmt_sys_id,newSys).subscribe(
                    (response) => {
  									console.log(response);
  									if(response.Error)
										{
											this.messager.openSnackBar("Form did not save due to: [ " + response.data.Message + "] " , '', 'errorAlert');
										}
										else{

                        this.messager.openSnackBar("System Saved Successfully", '', 'successAlert');
										}
  								}, err => {

                  });

  								this.service.updateEquipmentStamp(this.data.submittedData[index].sbmt_eq_id,newEq).subscribe(
                    (response) => {
							  									console.log(response);
							  									if(response.Error)
																	{
																		this.messager.openSnackBar("Form did not save due to: [ " + response.data.Message + "]", '', 'errorAlert');
																	}
																	else{
																		this.messager.openSnackBar('Equipment saved', '', 'successAlert');
																	}
							  	}, err => {

                  });




  }





}
